module.exports = __webpack_public_path__ + "static/Toggle2-81e74018768829ca6caec873c469381e.png";